import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {TokenService} from '@core';
import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private token: TokenService,
    private router: Router
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const logoutHandler = () => {
      if (request.url.includes('/auth/logout')) {
        this.router.navigateByUrl('/auth/login').then();
      }
    };

    if (this.token.valid()) {
      return next
        .handle(
          request.clone({
            headers: request.headers.append('x-auth-token', this.token.getToken() as string),
            withCredentials: true,
          })
        )
        .pipe(
          tap(() => logoutHandler()),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              this.token.clear();
            }
            return throwError(error);
          })
        );
    }

    return next.handle(request).pipe(tap(() => logoutHandler()));
  }
}
